import type { HTTPFunctions } from '../types';

const share = ({ get, post }: HTTPFunctions) => ({
  getUsersShared: (documentId: string) => get(`share/users/shared/${documentId}`),
  getUsersToShare: (documentId: string) => get(`share/users/permissions/${documentId}`),
  setUsersToShare: (documentId: string, data: any) => post('share/users/permissions', {...data, document_id: documentId})
});

export default share;